import { render, staticRenderFns } from "./ModalInstructionsScopes.vue?vue&type=template&id=fba7fada"
import script from "./ModalInstructionsScopes.vue?vue&type=script&lang=js"
export * from "./ModalInstructionsScopes.vue?vue&type=script&lang=js"
import style0 from "./ModalInstructionsScopes.vue?vue&type=style&index=0&id=fba7fada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports